import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    ClientName: {
      validations: []
    },
    FirstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    LastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    TelNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' },
      ]
    },
    Email: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' },

      ]
    },
    Description: {
      validations: []
    },
    SiteName: {
      validations: []
    },
    EventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future.' },
      ]
    },
    PlannedGuestCount: {
      validations: [
        {type: 'regex', pattern: '^[0-9]*$', message: 'Please provide in numbers only.'},
      ]
    },
    Theme: {
      validations: []
    },
    EventExtra1: {
      validations: [
        { type: 'maxLength', maxLength: 50, message: '50 character maximum.' }
      ]
    },
    Notes: {
      validations: []
    },
    EventExtra7: {
      validations: [
        { type: 'maxLength', maxLength: 50, message: '50 character maximum.' }
      ]
    },
    EventExtra8: {
      validations: []
    },
    Reference: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'REQUEST A QUOTE',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company/Organization (If applicable)',
            mapping: 'ClientName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name *',
            mapping: 'FirstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name *',
            mapping: 'LastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone',
            mapping: 'TelNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email *',
            mapping: 'Email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'checkbox-list',
            size: 'Medium',
            label: 'Event Type',
            options: [
              { label: 'Private' , value: 'Private'},
              { label: 'Corporate', value: 'Corporate'},
              { label: 'Wedding', value: 'Wedding'},
              { label: 'Charitable', value: 'Charitable'},
              { label: 'Gala', value: 'Gala'},
              { label: 'Other', value: 'Other'}
            ],
            mapping: 'Description'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Venue (Include ceremony site if applicable)',
            mapping: 'SiteName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date',
            mapping: 'EventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of Guests',
            mapping: 'PlannedGuestCount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Type of Service',
            options: [
              { label: 'Buffet' , value: 'Buffet'},
              { label: 'Family Style', value: 'Family Style'},
              { label: 'Plated', value: 'Plated'},
              { label: 'Station', value: 'Station'},
              { label: 'Appetizer', value: 'Appetizer'}
            ],
            mapping: 'Theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'checkbox-list',
            size: 'Medium',
            label: 'Additional Menu Items',
            options: [
              { label: 'Appetizers', value: 'Appetizers' },
              { label: 'Dessert', value: 'Dessert' },
              { label: 'Infused Water Station', value: 'Infused Water Station' },
              { label: 'Bar Service', value: 'Bar Service' },
              { label: 'Wine Table Service', value: 'Wine Table Service' },
              { label: 'Coffee and Tea', value: 'Coffee and Tea' },
            ],
            mapping: 'EventExtra1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Total Budget for Food, Drink, Labor and Rentals',
            mapping: 'Notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Additional Notes and Special Requests',
            mapping: 'EventExtra7'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'What is the preferred method and time of contact?',
            mapping: 'EventExtra8'
          }
        ]
      },
      {
        fields: [
          {
            type: 'checkbox-list',
            size: 'Medium',
            label: 'How did you hear about us?',
            options: [
              { label: 'Referral', value: 'Referral' },
              { label: 'Attended an Event', value: 'Attended an Event' },
              { label: 'Repeat Client', value: 'Repeat Client' },
              { label: 'Wedding Planner', value: 'Wedding Planner' },
              { label: 'Instagram', value: 'Instagram' },
              { label: 'Venue', value: 'Venue' },
              { label: 'Google', value: 'Google' },
              { label: 'Magazine', value: 'Magazine' },
              { label: 'Other', value: 'Other' }
            ],
            mapping: 'Reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'White Table Catering Contact Form',
    formId: '478',
    clientKey: 'CFF4BD37-E0B7-437D-BAA8-399C50E61B47',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/whitetablecatering/form_structure.js